// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"150":"b8a42dae77bd256c8e91","442":"1e3ef1139912dd1e5990","671":"2cb57a6cb59b79c3c168"}[chunkId] + ".js";
};